/**
 * Plan To Use Insurance Guard
 *
 * Guards that check if the patient intends to use insurance for this visit.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Plans To Use Insurance Guard
 *
 * Checks if the patient answered "Yes" to the insurance question.
 * This determines whether the travel insurance question is shown,
 * or whether the patient skips straight to self-pay pricing.
 *
 * NOTE: Guards run BEFORE actions, so we check event.data (not context)
 */
export const planToUseInsurance: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    if (event.data && typeof event.data.planToUseInsurance === "boolean") {
      return event.data.planToUseInsurance === true;
    }

    // Fallback to context (for state restoration)
    return context.planToUseInsurance === true;
  },
  metadata: {
    displayName: "planToUseInsurance",
    description: "Patient answered YES to plan to use insurance question",
    requiresContext: ["planToUseInsurance"],
    category: "context",
  },
};
